import { db } from "../../../service/API";

export class ProfileAccountConnector {
  constructor(userData) {
    this.socId = userData.socId;
  }

  getAccountInfos() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileAccountConnector/getAccountInfos/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get account data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get account data : " + err.message);
        });
    });
  }
}
